import { render } from "./SectorsListing.vue?vue&type=template&id=444ff9c7&ts=true"
import script from "./SectorsListing.vue?vue&type=script&lang=ts"
export * from "./SectorsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__